import React from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { SlArrowDown } from "react-icons/sl";
import { BiEnvelope } from "react-icons/bi";
import { HiDotsVertical } from "react-icons/hi";

import FilterForm from "./FilterForm";

import { setProfileBoxAction } from "../../redux/auth/auth-slice";
import {
  setPageNext,
  setPagePrev,
  setFilteredBookings,
  setFilteredBookingsNumber,
  setIsSearch,
  clearFilterBooking,
  setFilterForm,
} from "../../redux/booking/booking-slice";

import {
  ArrowLeft as ArrowLeftIcon,
  Search as SearchIcon,
} from "../../assets/svg";

import { cn } from "../../utils/lib";

import OrderTabs from "./order-tabs";
import { X } from "lucide-react";

export default function Navbar({ className }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { pageCount, totalBookingCount, filterForm } = useSelector(
    (state) => state.booking,
  );

  const { user, token, profileBoxAction } = useSelector((state) => state.auth);
  const { filteredBookings, isSearch } = useSelector((state) => state.booking);

  const [openlogoutModal, setopenlogoutModal] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);

  const [searchItem, setsearchItem] = React.useState("");
  const { pathname } = useLocation();

  const profileBoxRef = React.useRef(null);
  React.useEffect(() => {
    const handleDown = (e) => {
      if (profileBoxRef.current && !profileBoxRef.current.contains(e.target)) {
        dispatch(
          setProfileBoxAction({
            profileBoxAction: false,
          }),
        );
      }
    };

    document.addEventListener("mousedown", handleDown);
    document.addEventListener("touchstart", handleDown);

    return () => {
      document.removeEventListener("mousedown", handleDown);
      document.removeEventListener("touchstart", handleDown);
    };
  }, []);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (searchItem?.length > 2) {
        dispatch({
          type: "FILTER_AFFILIATE",
          payload: {
            token: token,
            affiliateId: user?._id,
            searchItem: searchItem,
          },
        });
      } else {
        dispatch(
          setFilteredBookings({
            filteredBookings: [],
          }),
        );
        dispatch(
          setFilteredBookingsNumber({
            filteredBookingsLength: 0,
          }),
        );
      }
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [searchItem]);

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center border-b border-gray-700 px-3 pt-5",
        className,
      )}
    >
      <div className="flex w-full items-start justify-between">
        <div className="flex items-center justify-between space-x-6">
          {token && (
            <div className="col-span-6 block">
              {pathname === "/orders" && (
                <div className="shadow-[0px_4px_10px_0px_rgba(0,0,0,0.10) flex h-9 w-full items-center rounded-full border border-[#353C4A] bg-[#181E29]">
                  <label htmlFor="search" className="mx-5 my-3 cursor-pointer">
                    <SearchIcon className="size-3" />
                  </label>
                  <input
                    onChange={(e) => {
                      setsearchItem(e.target.value);
                      if (e.target.value === "") {
                        dispatch(clearFilterBooking());
                      }
                    }}
                    value={searchItem}
                    id="search"
                    type="search"
                    className="flex-grow bg-transparent outline-none"
                    placeholder="Search..."
                    autoComplete="off"
                  />
                  {pathname === "/orders" && (
                    <div
                      className="my-3 mr-5 cursor-pointer"
                      onClick={() => setShowModal(true)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M0.5 4.1749H8.64103C8.86559 5.08221 9.68634 5.75699 10.6621 5.75699C11.6378 5.75699 12.4585 5.08221 12.6831 4.1749H15.5C15.7761 4.1749 16 3.95102 16 3.6749C16 3.39877 15.7761 3.1749 15.5 3.1749H12.6831C12.4585 2.26759 11.6378 1.59277 10.662 1.59277C9.68628 1.59277 8.86553 2.26759 8.641 3.1749H0.5C0.223875 3.1749 0 3.39877 0 3.6749C0 3.95102 0.223875 4.1749 0.5 4.1749ZM10.6621 2.59277C11.2587 2.59277 11.7442 3.07821 11.7442 3.67487C11.7442 4.27155 11.2587 4.75699 10.6621 4.75699C10.0654 4.75699 9.57994 4.27155 9.57994 3.67487C9.57994 3.07821 10.0654 2.59277 10.6621 2.59277ZM0.5 8.49952H3.31694C3.5415 9.40684 4.36222 10.0816 5.33797 10.0816C6.31372 10.0816 7.13444 9.40684 7.359 8.49952H15.5C15.7761 8.49952 16 8.27565 16 7.99952C16 7.7234 15.7761 7.49952 15.5 7.49952H7.35897C7.13441 6.59221 6.31369 5.9174 5.33794 5.9174C4.36219 5.9174 3.54147 6.59221 3.31691 7.49952H0.5C0.223875 7.49952 0 7.7234 0 7.99952C0 8.27565 0.223844 8.49952 0.5 8.49952ZM5.33794 6.9174C5.93462 6.9174 6.42006 7.40284 6.42006 7.99952C6.42006 8.59618 5.93462 9.08162 5.33794 9.08162C4.74125 9.08162 4.25581 8.59618 4.25581 7.99952C4.25581 7.40284 4.74125 6.9174 5.33794 6.9174ZM15.5 11.8241H12.6831C12.4585 10.9168 11.6378 10.242 10.662 10.242C9.68628 10.242 8.86556 10.9168 8.641 11.8241H0.5C0.223875 11.8241 0 12.048 0 12.3241C0 12.6003 0.223875 12.8241 0.5 12.8241H8.64103C8.86559 13.7315 9.68631 14.4063 10.6621 14.4063C11.6378 14.4063 12.4585 13.7315 12.6831 12.8241H15.5C15.7761 12.8241 16 12.6003 16 12.3241C16 12.048 15.7762 11.8241 15.5 11.8241ZM10.6621 13.4063C10.0654 13.4063 9.57994 12.9208 9.57994 12.3241C9.57994 11.7275 10.0654 11.242 10.6621 11.242C11.2587 11.242 11.7442 11.7275 11.7442 12.3241C11.7442 12.9208 11.2587 13.4063 10.6621 13.4063Z"
                          fill="#B1B1B1"
                        />
                      </svg>
                    </div>
                  )}
                </div>
              )}

              {pathname === "/orders" && !isSearch && <OrderTabs />}

              {pathname === "/orders" && isSearch && (
                <div className="my-2 flex flex-col space-y-4">
                  <div className="flex items-center justify-start space-x-3">
                    <div className="text-lg font-semibold">Search Results</div>
                    <div className="rounded-full bg-white px-2 text-lg text-black">
                      {filteredBookings?.length}
                    </div>
                  </div>
                </div>
              )}

              {showModal && (
                <FilterForm onModalOff={() => setShowModal(false)} />
              )}
            </div>
          )}
        </div>

        {/* Profile and Icon */}
        <div className="flex flex-wrap-reverse items-center">
          {token && (
            <>
              {/* <div
                className="sm:hidden"
                onClick={() => {
                  dispatch(setProfileBoxAction({ profileBoxAction: true }));
                }}
              >
                <div>
                  <HiDotsVertical className="h-6 w-10 text-white/80" />
                </div>
              </div> */}

              {/* TOP PAGINATION */}
              <div className="mb-5 hidden flex-wrap-reverse items-center justify-end gap-2 space-x-[18px] sm:flex">
                {pathname === "/orders" && !isSearch && (
                  <div className="flex items-center gap-x-3 text-center text-base font-semibold leading-[18px] text-[#A4A4A4]">
                    {/* Page Range */}
                    <div className="text-base font-semibold">
                      {(pageCount - 1) * 10 + 1}-
                      {pageCount * 10 < totalBookingCount
                        ? pageCount * 10
                        : totalBookingCount}
                    </div>

                    {/* Pagination Buttons */}
                    <div
                      onClick={() => {
                        if (pageCount > 1) dispatch(setPagePrev());
                      }}
                      className="relative flex size-5 items-center justify-center rounded-full border border-[#353C4A] bg-[#181E29] p-2"
                    >
                      <ArrowLeftIcon
                        className={cn(
                          "absolute left-1/2 top-1/2 size-2 -translate-x-1/2 -translate-y-1/2 text-red-600 shadow-[0px_4px_10px_0px_rgba(0,0,0,0.10)]",
                          pageCount > 1
                            ? "cursor-pointer text-white"
                            : "cursor-not-allowed text-[#A4A4A4]",
                        )}
                      />
                    </div>

                    <div
                      className="relative flex size-5 items-center justify-center rounded-full border border-[#353C4A] bg-[#181E29] p-2"
                      onClick={() => {
                        if (pageCount < Math.ceil(totalBookingCount / 10))
                          dispatch(setPageNext());
                      }}
                    >
                      <ArrowLeftIcon
                        className={cn(
                          "absolute left-1/2 top-1/2 size-2 -translate-x-1/2 -translate-y-1/2 rotate-180 text-red-600 shadow-[0px_4px_10px_0px_rgba(0,0,0,0.10)]",
                          pageCount < Math.ceil(totalBookingCount / 10)
                            ? "cursor-pointer text-white"
                            : "cursor-not-allowed text-[#A4A4A4]",
                        )}
                      />
                    </div>

                    {/* Page Range */}
                    <div className="text-nowrap rounded-sm border border-[#353C4A] bg-[#181E29] p-1 text-center text-base font-semibold leading-[18px] text-white">
                      1 - {totalBookingCount}
                    </div>
                  </div>
                )}

                <div
                  className="group flex h-9 w-fit cursor-pointer items-center space-x-1.5 rounded-full border-white bg-gray-900 py-2 pl-6 pr-4"
                  onClick={() => {
                    dispatch(setProfileBoxAction({ profileBoxAction: true }));
                  }}
                >
                  <div>
                    <h2 className="text-xs text-white/50">Welcome</h2>
                    <h2 className="-mt-0.5 text-white">
                      {user?.affiliateName}
                    </h2>
                  </div>
                  <SlArrowDown className="h-8 w-8 p-2 font-light text-white/80" />
                </div>
              </div>

              {profileBoxAction && (
                <div
                  ref={profileBoxRef}
                  className="popbox absolute right-4 top-4 z-50 h-auto w-[17.125rem] rounded-xl border border-white/30 bg-gradient-to-b from-slate-900 to-black pb-7 pt-4 shadow"
                >
                  <X
                    className="absolute right-4 top-4 size-4 text-white hover:cursor-pointer hover:text-gray-500"
                    onClick={() =>
                      dispatch(
                        setProfileBoxAction({
                          profileBoxAction: false,
                        }),
                      )
                    }
                  />

                  <div className="flex justify-center">
                    <img
                      src={user?.logo?.secure_url}
                      alt=""
                      className="h-16 w-16 rounded-full bg-white/60 p-[1px]"
                    />
                  </div>

                  <h2 className="my-2 text-center font-semibold text-white">
                    {user?.affiliateName}
                  </h2>

                  <div className="mx-4">
                    <h2 className="py-1.5 text-sm text-white">Email address</h2>
                    <div className="flex items-center space-x-2 rounded-lg border-[#dddddd] bg-white px-2 py-2.5 text-center">
                      <BiEnvelope className="text-2xl text-slate-600" />
                      <h2 className="truncate text-base font-normal text-slate-600">
                        {user?.email1}
                      </h2>
                    </div>
                  </div>

                  <div className="mx-4 my-3">
                    <div
                      className="cursor-pointer rounded-lg border border-blue-900 bg-blue-600 py-2 text-center text-base font-semibold text-white"
                      onClick={() => {
                        setopenlogoutModal(!openlogoutModal);
                      }}
                    >
                      Log Out
                    </div>
                    {openlogoutModal && (
                      <div className="absolute bottom-0 right-0 z-10 w-[16.875rem] rounded-xl bg-black pb-3">
                        <div className="cursor-pointer px-5 py-3 text-center text-base font-medium text-white">
                          Are you sure to logout?
                        </div>
                        <div className="flex justify-center space-x-7">
                          <button
                            onClick={() => {
                              setopenlogoutModal(false);
                              dispatch(
                                setProfileBoxAction({
                                  profileBoxAction: false,
                                }),
                              );
                              // setopenprofileBox(false);
                            }}
                            className="rounded-md bg-[#858597] px-5 py-1 text-white"
                          >
                            No
                          </button>
                          <button
                            onClick={() => {
                              setopenlogoutModal(!openlogoutModal);

                              dispatch({
                                type: "AUTH_LOGOUT",
                                payload: { navigate, email: user?.email1 },
                              });
                            }}
                            className="rounded-md bg-blue-600 px-5 py-1 text-white"
                          >
                            Yes
                          </button>
                        </div>
                      </div>
                    )}
                    <div className="mt-4 flex flex-col items-start gap-1 text-left font-sans text-xs sm:text-sm">
                      <Link
                        to="/TermsConditions"
                        className="text-sm hover:text-blue-600 hover:underline"
                      >
                        Terms and Conditions
                      </Link>
                      <Link
                        to="/PrivacyPolicy"
                        className="text-sm hover:text-blue-600 hover:underline"
                      >
                        Privacy Policy
                      </Link>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {pathname === "/orders" && (
        <>
          {isSearch && (
            <div className="flex w-full flex-wrap items-center justify-start gap-2 gap-x-2 py-2">
              {Object.keys(filterForm)?.map((item) => {
                if (filterForm[item] && item !== "dateType") {
                  let data = filterForm[item];
                  if (
                    item === "singleDate" ||
                    item === "startDate" ||
                    item === "endDate"
                  ) {
                    data = moment(filterForm[item])?.format("DD-MM-YYYY");
                  }

                  return (
                    <div className="chip-border-gradient rounded-full p-[2px]">
                      <div className="rounded-full bg-black">
                        <div className="flex h-8 items-center justify-center space-x-[7px] rounded-full px-[11.5px] py-2">
                          <div>{data}</div>
                          <div
                            className="cursor-pointer"
                            onClick={() => {
                              const newo = { ...filterForm };
                              const dispatchObj = {
                                ...newo,
                                [item]: "",
                              };
                              dispatch(setFilterForm(dispatchObj));
                              let count = 0;
                              Object.keys(newo)?.forEach((key) => {
                                if (newo[key] && key !== "dateType") {
                                  count++;
                                }
                              });
                              console.log(count);
                              if (count === 1 || count === 0) {
                                dispatch(clearFilterBooking());
                                return;
                              }
                              dispatch(setIsSearch({ isSearch: true }));
                              const payload = {
                                token: token,
                                affiliateId: user?._id,
                                ...dispatchObj,
                              };
                              dispatch({
                                type: "FILTER_AFFILIATE_COMPLETE",
                                payload: payload,
                              });
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="17"
                              height="16"
                              viewBox="0 0 17 16"
                              fill="none"
                            >
                              <path
                                d="M4.5 4L12.5 12"
                                stroke="#787878"
                                stroke-width="1.5"
                                stroke-linecap="round"
                              />
                              <path
                                d="M4.5 12L12.5 4"
                                stroke="#787878"
                                stroke-width="1.5"
                                stroke-linecap="round"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }
              })}

              <div
                className="size-8 cursor-pointer rounded-full bg-white"
                onClick={() => {
                  dispatch(setIsSearch({ isSearch: false }));
                  dispatch(clearFilterBooking());
                }}
              >
                <svg
                  className="mx-auto h-full"
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                >
                  <g clip-path="url(#clip0_65_119)">
                    <path
                      d="M9.95781 1.63887H11.1625C11.4906 1.63887 11.7578 1.37168 11.7578 1.04355C11.7578 0.71543 11.4906 0.448242 11.1625 0.448242H8.78125C8.45313 0.448242 8.18594 0.71543 8.18594 1.04355V3.4248C8.18594 3.75293 8.45313 4.02012 8.78125 4.02012C9.10938 4.02012 9.37656 3.75293 9.37656 3.4248V2.68184C10.5039 3.58184 11.1625 4.93184 11.1625 6.40137C11.1625 9.02637 9.025 11.1639 6.4 11.1639C6.07187 11.1639 5.80469 11.4311 5.80469 11.7592C5.80469 12.0873 6.07187 12.3545 6.4 12.3545C9.68359 12.3545 12.3531 9.68496 12.3531 6.40137C12.3531 4.49824 11.4625 2.75918 9.95781 1.63887Z"
                      fill="#555555"
                    />
                    <path
                      d="M4.01914 8.78262C3.69102 8.78262 3.42383 9.0498 3.42383 9.37793V10.1209C2.29648 9.2209 1.63789 7.87324 1.63789 6.40137C1.63789 3.77637 3.77539 1.63887 6.40039 1.63887C6.72852 1.63887 6.9957 1.37168 6.9957 1.04355C6.9957 0.71543 6.72852 0.448242 6.40039 0.448242C3.1168 0.448242 0.447266 3.11777 0.447266 6.40137C0.447266 8.30684 1.33555 10.0436 2.84258 11.1639H1.63789C1.30977 11.1639 1.04258 11.4311 1.04258 11.7592C1.04258 12.0873 1.30977 12.3545 1.63789 12.3545H4.01914C4.34727 12.3545 4.61445 12.0873 4.61445 11.7592V9.37793C4.61445 9.0498 4.34727 8.78262 4.01914 8.78262Z"
                      fill="#555555"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_65_119">
                      <rect
                        width="12"
                        height="12"
                        fill="white"
                        transform="translate(0.400391 0.401367)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
          )}

          <div className="bottom-0 h-px bg-gradient-to-r from-[#111111] via-[#848484] to-[#111111]" />
        </>
      )}
    </div>
  );
}
